import '@client-side-validations/client-side-validations'
import '@client-side-validations/simple-form'

$(document).on('focusout', 'form#new_user input', function() {
  if ($(this).val() == '' || $(this).val() == undefined) {
    ClientSideValidations.formBuilders['SimpleForm::FormBuilder'].add($(this), $(this).parents('form').data('clientSideValidations').html_settings, "Can't be blank")
  }
});

$(document).on('change', "form#new_user input[id$='_terms_and_conditions']", function() {
  if ($(this).prop('checked') == true) {
    $(this).parents('form').find(':submit').prop('disabled', false)
  } else {
    $(this).parents('form').find(':submit').prop('disabled', true)
  }
});

